export const years = ['2022', '2023', '2024', '2025']

/**
 * Company object paired with its' id (used by backend)
 */
export const companies = [
    { id: 1, name: "Vinimark Holdings" }
]

/**
 * Default Vinimark Trading Facilities, paired with their id (used by backend)
 */
export const vinimarkTradingFacilities = [
    { id: 4, name: 'Klapmuts' },
    { id: 5, name: 'Head Office' },
    { id: 6, name: 'Johannesburg' },
    { id: 7, name: 'KwaZulu-Natal' },
    { id: 8, name: 'Mbombela' },
    { id: 9, name: 'Gqeberha' },
]

/**
 * Default Reyneke Wines Facilities, paired with their id (used by backend)
 */
export const reynekeWinesFacilities = [
    { id: 1, name: 'Reyneke Wines' },
    { id: 2, name: 'Reyneke Wines Properties' },
]

/**
 * Default Twee Jonge Gezellen Facilities, paired with their id (used by backend)
 */
export const tweeJongeGezellenFacilities = [
    { id: 3, name: 'Twee Jonge Gezellen' }
]

export const facilities = [...reynekeWinesFacilities, ...tweeJongeGezellenFacilities, ...vinimarkTradingFacilities]

/**
 * Hierarchic object which ties facilities together under their respective group
 */
export const groups = [
    { id: 1, name: 'Vinimark Trading', facilities: vinimarkTradingFacilities },
    { id: 2, name: 'Reyneke Wines', facilities: reynekeWinesFacilities },
    { id: 3, name: 'Twee Jonge Gezellen', facilities: tweeJongeGezellenFacilities },
]

/**
 * Default, unfiltered category arrays. These will be subject to filtering by business logic
 */
export const categoryOneArray = ['Diesel - Stationary', 'Diesel - Mobile', 'Petrol - Mobile', 'Refrigerant Gas', 'LPG', 'Dry Ice', 'Fertilizer Applied', 'Agrochemicals Applied']
export const categoryTwoArray = ['Electricity Purchased', 'Renewable Energy Produced']
export const categoryThreeArray = ['Flights and Accommodation', 'Car Hire', 'Petrol Cards',
    'Inter-DC Distribution', 'Farm-DC Distribution', 'Shipping Distribution', 'Regional Distribution']
export const categoryFourArray = ['Water', 'Chemicals and Additives', 'Wooden Products', 'Packaging', 'Wine and Grapes', 'Other', 'Capital Goods and Services']
export const categoryFiveArray = ['Waste to Landfill', 'Waste to Recycling', 'Waste to Composting',
    'Wastewater Treatment', 'Waste to Biochar Production']

/**
* When we select a name, we can .find the categories associated with it.
*/
export const originalCategories = [
    { name: "Category One", categories: categoryOneArray },
    { name: "Category Two", categories: categoryTwoArray },
    { name: "Category Three", categories: categoryThreeArray },
    { name: "Category Four", categories: categoryFourArray },
    { name: "Category Five", categories: categoryFiveArray }
]

export const generalInformationOptions = [
    'Asset List',
    'Supplier List',
    'Petrol Card Holder List',
    'Intensity Metrics',
    'Employee Commuting',
    'Plot List',
    'Agrochemical List',
    'Fertilizer List',
]

export const conversionFactors = [
    'Spend-Based Conversion Factors',
    'Emission Factors',
]